/* eslint react/prop-types: off */
/* eslint no-unused-vars: off */

import { faPen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from "services/api";;
import Flex from 'components/common/Flex';
import { widgetRegister } from 'data/widgets';
import { API3_HOST } from 'helpers/urlHelper';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { Bounce, toast } from 'react-toastify';
import {
  deleteWidget,
  renameDashboard,
  updateDashboardLayout,
  updateWidget
} from 'services/dashboardService';
import AddWidgetModal from './AddWidgetModal';
import DashboardEditControls from './DashboardEditControls';
import DashboardViewControls from './DashboardViewControls';
import WidgetGrid from './WidgetGrid';
import WidgetWrapper from './WidgetWrapper';
import CommonWidgetOptions from 'components/widgets/CommonWidgetOptions';

/***
 * Main dashboard page for viewing / editing dashboards.
 * Widgets can be edited and configured if the user has correct permissions.
 */

export default function Dashboard(props) {
  // Array of widget references
  // This is used to call the reloadData function on each widget when the dashboard is reloaded
  const widgetRefs = useRef([]);

  // Get the dashboard ID from the URL
  let { id } = useParams();
  const [isEditMode] = useState(props.edit);
  const [isLoading, setIsLoading] = useState(true);
  const [dashboard, setDashboard] = useState(false);
  const [addWidgetModalShow, setAddWidgetModalShow] = useState(false);

  // Layout
  const [layout, setLayout] = useState({});

  // Widget editing
  const [editWidget, setEditWidget] = useState({});
  const [editWidgetOptions, setEditWidgetOptions] = useState({});
  const [editWidgetModalShow, setEditWidgetModalShow] = useState(false);
  const [allQueries, setAllQueries] = useState([]);
  const [editModalName, setEditModalName] = useState('');
  const [editModalQueryId, setEditModalQueryId] = useState(0);
  const [editModalRequestMethod, setEditModalRequestMethod] = useState('');
  const [editModalRequestUrl, setEditModalRequestUrl] = useState('');

  const [autoRefreshInterval, setAutoRefreshInterval] = useState("30");
  const [autoRefreshIntervalTimerId, setAutoRefreshIntervalTimerId] = useState(0);

  // Load all available queries
  // This is used to populate the query dropdown when editing a widget
  const loadAllQueries = () => {
    axios({
      method: 'get',
      url: `${API3_HOST}/dashboard/query/`
    })
      .then(result => {
        setAllQueries(result.data);
      })
      .catch(err => {
        console.log('bad result', err);
      });
  };

  // Load the dashboard data from the API
  // This is used to populate the dashboard with widgets and data
  // This is called when the dashboard is first loaded and when the user saves the layout
  const loadData = () => {
    setIsLoading(true);
    axios({
      method: 'get',
      url: `${API3_HOST}/dashboard/dashboard/${id}`
    })
      .then(result => {
        setDashboard(result.data);
        setIsLoading(false);
        getAutoRefreshInterval();
      })
      .catch(err => {
        console.error('Failed to load dashboard data', err);
      });
  };

  // First load, load all queries and dashboard data
  useEffect(() => {
    loadAllQueries();
    loadData();
    
  }, []);

  // Reload all the widgets without reloading the page & dashboard layout 
  const reloadWidgets = () => {
    for (let i = 0; i < widgetRefs.current.length; i++) {
      widgetRefs.current[i].reloadData(); // Focus the specific input field
    }
  };

  // Setup edit widget if we are in edit mode and a widget is selected
  useEffect(() => {
    if (isEditMode && Object.keys(editWidget).length > 0) {
      setEditModalName(editWidget.name);
      setEditModalQueryId(editWidget.queryId);
      setEditModalRequestMethod(editWidget.requestMethod);
      setEditModalRequestUrl(editWidget.requestUrl);
      setEditWidgetModalShow(true);
      if (editWidget.options && editWidget.options.length > 2) {
        setEditWidgetOptions(JSON.parse(editWidget.options));
      } else {
        setEditWidgetOptions({});
      }
    }
  }, [editWidget]);

  useEffect(() => {}, [layout]);

  // Auto Refresh ---
  const getAutoRefreshInterval = () => {
    
    let key = `dashboard.autorefreshinterval.${id}`;
    console.log(id, key)
    let val = localStorage.getItem(key)
    if (val != null) {
      setAutoRefreshInterval(val);
    }
  }

  useEffect(() => {
    // clear timer
    if (autoRefreshIntervalTimerId > 0) {
      clearInterval(autoRefreshIntervalTimerId);
    }
    localStorage.setItem(`dashboard.autorefreshinterval.${dashboard.id}`, autoRefreshInterval);

    let intervalSecs = parseInt(autoRefreshInterval);

    if (isNaN(intervalSecs) || intervalSecs < 0) {
      return;
    }

    // start timer
    let id = setInterval(() => {
      reloadWidgets();
    }, intervalSecs * 1000);

    setAutoRefreshIntervalTimerId(id);

  }, [autoRefreshInterval]);

  // Render a spinner if we are still loading data
  if (isLoading) {
    return (
      <div className="text-center">
        <Spinner variant="primary" animation="border" role="status"></Spinner>
      </div>
    );
  }

  return (
    <>
     {/* Add widget modal for adding new widgets to the dashboard */}
      <AddWidgetModal
        dashboardId={id}
        title="Create New Dashboard"
        endpoint="/dashboard/dashboard/"
        redirect="/dashboard/edit/"
        show={addWidgetModalShow}
        onHide={() => {
          setAddWidgetModalShow(false);
          reloadWidgets();
        }}
      ></AddWidgetModal>

      {/* Edit widget modal for editing existing widgets on the dashboard */}
      <Modal
        show={editWidgetModalShow}
        onHide={() => {
          setEditWidgetModalShow(false);
          reloadWidgets();
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit - '{editWidget.name}'
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3">
          <>
            <Form.Group className="mb-3">
              <Form.Label>Widget Name</Form.Label>
              <Form.Control
                type="text"
                value={editModalName}
                onChange={e => setEditModalName(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Query</Form.Label>
              <Form.Select
                value={editModalQueryId}
                defaultValue={editModalQueryId}
                onChange={e => setEditModalQueryId(e.target.value)}
              >
                <option key={0} value={0}>
                  No Query
                </option>
                {allQueries.map((option, index) => {
                  return (
                    <option key={index} value={option.id}>
                      {option.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
         
            <a href={`/dashboard/queries`} target="__blank">
              &nbsp;Queries
            </a>
            <br></br><br></br>
            <Form.Group>
              <Form.Label>Request Method</Form.Label>
              <Form.Control type="text" value={editModalRequestMethod} onChange={(e) => setEditModalRequestMethod(e.target.value)} placeholder='GET'/>
            </Form.Group>
            <Form.Group>
              <Form.Label>Request URL</Form.Label>
              <Form.Control type="text" value={editModalRequestUrl} onChange={(e) => setEditModalRequestUrl(e.target.value)}/>
            </Form.Group>
          </>
          <EditWidgetOptions
            editWidget={editWidget}
            editWidgetOptions={editWidgetOptions}
            editWidgetOptionsOnChange={setEditWidgetOptions}
          ></EditWidgetOptions>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() => {
              if (confirm('Are you sure you want to delete this widget?')) {
                deleteWidget(editWidget.id)
                  .then(() => {
                    setEditWidgetModalShow(false);
                    loadData();
                  })
                  .catch(err => {
                    console.log('bad result', err);
                  });
              }
            }}
          >
            Delete Widget
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              updateWidget(
                editWidget.id,
                editModalName,
                editModalQueryId,
                editModalRequestMethod,
                editModalRequestUrl,
                editWidgetOptions
              );
              setEditWidgetModalShow(false);
              loadData();
            }}
          >
            Save
          </Button>
        </Modal.Footer>{' '}
      </Modal>
          
      {/* Dashboard header with view / edit controls and title */}
      <Card className="bg-100 shadow-none border mb-3">
        <Card.Body className="py-3">
          <Row className="g-0 justify-content-between">
            <Col sm="auto">
              <Flex alignItems="center">
                <div>
                  <h4 className="text-primary fw-bold mb-0">
                    {isEditMode
                      ? `Editing '${dashboard.name}'`
                      : dashboard.name}
                    &nbsp;
                    {isEditMode ? (
                      <Button
                        className="ml-2"
                        size="sm"
                        onClick={() => {
                          let name = prompt('Rename dashboard');
                          if (name && name.length > 0) {
                            renameDashboard(dashboard.id, name).then(res => {
                              window.location.reload();
                            });
                          }
                        }}
                      >
                        <FontAwesomeIcon icon={faPen} />
                      </Button>
                    ) : (
                      <></>
                    )}
                  </h4>
                </div>
              </Flex>
            </Col>
      
            {isEditMode ? (
            
              <DashboardEditControls
                onViewClick={() => {
                  window.location = `/dashboard/view/${dashboard.id}`;
                }}
                onAddWidgetClick={() => {
                  setAddWidgetModalShow(true);
                }}
                onSaveLayoutClick={() => {
                  if (dashboard && Object.keys(layout).length > 0) {
                    updateDashboardLayout(dashboard.id, layout)
                      .then(res => {
                        toast.success('Dashboard Layout Saved', {
                          position: 'top-right',
                          autoClose: 3000,
                          hideProgressBar: true,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          progress: undefined,
                          theme: 'dark',
                          transition: Bounce
                        });
                      })
                      .catch(err => {
                        toast.error('Failed to save dashboard layout', {
                          position: 'top-right',
                          autoClose: 3000,
                          hideProgressBar: true,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          progress: undefined,
                          theme: 'dark',
                          transition: Bounce
                        });
                      });
                  }
                }}
              ></DashboardEditControls>
            ) : (
              <DashboardViewControls
                dashboardId={dashboard.id}
                onEditClick={() => {
                  window.location = `/dashboard/edit/${dashboard.id}`;
                }}
                onRefreshClick={() => {
                  reloadWidgets();
                }}
                autoRefreshInterval={autoRefreshInterval}
                onAutoRefreshIntervalChange={(e) => {
                  setAutoRefreshInterval(e.target.value);
                  console.log(autoRefreshInterval, e.target.value)
                }}
              ></DashboardViewControls>
            )}
          </Row>
        </Card.Body>
      </Card>

      {/* Dashboard layout grid for displaying widgets, edit mode allows widgets to be moved / resized */}
      <WidgetGrid
        dashboardId={dashboard.id}
        onLayoutChange={layout => {
          setLayout(layout);
        }}
        canEdit={isEditMode ? true : false}
      >
  
        {dashboard.widgets.map((widget, index) => (
          <WidgetWrapper
            key={widget.id}
            widget={widget}
            onClick={() => {
              if (isEditMode) {
                setEditWidget(widget);
              }
            }}
            onRightClick={() => {}}
            ref={el => (widgetRefs.current[index] = el)}
          ></WidgetWrapper>
        ))}
      </WidgetGrid>
    </>
  );
}

Dashboard.propTypes = {
  data: PropTypes.object,
  edit: PropTypes.bool
};

// EditWidgetOptions component for displaying widget options in the edit modal
// This is used to display the options for each widget type
function EditWidgetOptions(props) {
  let editWidget = props.editWidget;
  if (!editWidget) return <></>;
  let reg = widgetRegister[editWidget.typeId];
  if (!reg) return <></>;
  if (!reg.options) return <></>;
  return (
    <>
      <hr></hr>
      <CommonWidgetOptions state={props.editWidgetOptions} onChange={props.editWidgetOptionsOnChange}></CommonWidgetOptions>
      <hr></hr>
      {reg.options(props.editWidgetOptions, props.editWidgetOptionsOnChange)}
    </>
  );
}